export const getFormFieldErrors = errors =>
    errors && errors.response && errors.response.statusCode === 422 ? errors.response.body : {};

export const getFormFieldError = (fieldName, errors) =>
    getFormFieldErrors(errors)[fieldName.replace('[', '.').replace(']', '')];
